import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ErrorLabel from "../error_label";
import $ from "jquery";
import {
  actionCdBalanceUpdate,
  resetCdBalanceUpdate,
  actionCdBalanceAdd,
  resetCdBalanceAdd,
} from "./../../routes/app/auth/list/store/index";
import toast from "react-hot-toast";
import {
  TOAST_DURATION,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../common/app_constant";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const CdAddEdit = (props) => {
  const [excel, setExcel] = useState();
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    setValue,
  } = useForm();

  const { CdBalanceUpdate, CdBalanceAdd } = useSelector((state) => ({
    ...state.listStore,
  }));

  const initialRender = () => {
    if (props.show === true) {
      $("#root").addClass("modal-open");
      $("#root").append('<div class="modal-backdrop fade show"></div>');
    } else {
      $("#root").removeClass("modal-open");
      $(".modal-backdrop").remove();
      reset();
    }
  };
  useEffect(initialRender, [props.show]);

  useEffect(() => {
    if (props.dataCd) {
      Object.keys(props.dataCd).forEach((key) => {
        setValue(key, props.dataCd[key]);
      });

      if (props.dataCd.payment_date) {
        const formattedDate = moment(
          props.dataCd.payment_date,
          "YYYY-MM-DD"
        ).format("DD-MM-YYYY");
        setValue("payment_date", formattedDate);
      }
    }
  }, [props.dataCd]);

  useEffect(() => {
    if (CdBalanceUpdate) {
      dispatch(resetCdBalanceUpdate());
      $("#add_edit_cd_balance").prop("disabled", false);
      if (CdBalanceUpdate.status === true) {
        setLoading(false)
        toast.success(CdBalanceUpdate.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        props.handleClose();
      } else {
        setLoading(false)
        toast.error(CdBalanceUpdate?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [CdBalanceUpdate]);

  useEffect(() => {
    if (CdBalanceAdd) {
      dispatch(resetCdBalanceAdd());
      $("#add_edit_cd_balance").prop("disabled", false);
      if (CdBalanceAdd.status === true) {
        setLoading(false)
        toast.success(CdBalanceAdd.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        props.handleClose();
      } else {
        setLoading(false)
        toast.error(CdBalanceAdd?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [CdBalanceAdd]);

  const onSubmit = (data) => {
    data.payment_date = moment(data?.payment_date, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    var input = { ...data };
    if (props.dataCd) {
      input.id = props.dataCd.id;
      $("#add-edit-cd-balance-loader").removeClass("hidden");
      $("#add_edit_cd_balance").prop("disabled", true);
      dispatch(
        actionCdBalanceUpdate({
          input,
          files: excel !== null ? [{ name: "file", value: excel[0] }] : [],
        })
      );
      setLoading(true)
    } else {
      $("#add-edit-cd-balance-loader").removeClass("hidden");
      $("#add_edit_cd_balance").prop("disabled", true);
      dispatch(
        actionCdBalanceAdd({
          input,
          files: excel !== null ? [{ name: "file", value: excel[0] }] : [],
        })
      );
      setLoading(true)
    }
  };
  return (
    <>
      <div
        class="modal fade show"
        id="cd"
        tabindex="-1"
        aria-labelledby="cdAddEdit"
        aria-hidden="true"
        style={{ display: `${props.show === true ? "block" : "none"}` }}
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="cdAddEdit">
                CD Balance {props.dataCd ? "Edit" : "Add"}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  props.handleClose();
                }}
              ></button>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                  <form
                    noValidate
                    autoComplete="Off"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="form-body">
                      <div className="row mb-3">
                        <div className="col-12 col-md-3">
                          <div className="form-group">
                            <label className="label-control">
                              CD Replenish Amount
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="credit"
                              name="credit"
                              {...register("credit", {
                                required: "This is required",
                              })}
                            />
                            {errors.credit && (
                              <ErrorLabel message={errors.credit?.message} />
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-3">
                          <div class="form-group has-search">
                            <label for="payment_date" class="form-label">
                              Payment Date
                              <span class="text-danger">*</span>
                            </label>
                            <span class="fa fa-calendar form-control-feedback"></span>
                            <Controller
                              name="payment_date"
                              control={control}
                              render={({ field }) => (
                                <Flatpickr
                                  {...field}
                                  onChange={(value) => {
                                    // console.log("Selected date:", value);
                                    var date = new Date(value).toISOString();
                                    // console.log("ISO date:", date);
                                    setValue(
                                      "payment_date",
                                      moment(date).format("DD-MM-YYYY")
                                    );
                                  }}
                                  id="disabled-picker"
                                  className="form-control"
                                  options={{
                                    dateFormat: "d-m-Y",
                                    enableTime: false,
                                    maxDate: "today", // Disables future dates
                                  }}
                                />
                              )}
                              rules={{
                                required: "This is required.",
                              }}
                            />
                            {errors.payment_date && (
                              <ErrorLabel
                                message={errors.payment_date?.message}
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group">
                            <label className="label-control">
                              Payment Reference Number
                            </label>
                            <input
                              className="form-control"
                              id="payment_ref_number"
                              name="payment_ref_number"
                              {...register("payment_ref_number", {
                                required: "This is required",
                              })}
                            />
                            {errors.payment_ref_number && (
                              <ErrorLabel
                                message={errors.payment_ref_number?.message}
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label className="label-control">Remark</label>
                            <input
                              className="form-control"
                              id="remark"
                              name="remark"
                              {...register("remark", {
                                required: "This is required",
                              })}
                            />
                            {errors.remark && (
                              <ErrorLabel message={errors.remark?.message} />
                            )}
                          </div>
                        </div>
                        <div className="col-12 mt-3">
                          <label htmlFor="formFile" className="form-label">
                            Attachment<span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            accept=".xlsx,.xls,.pdf,.doc,.docx,.jpeg,.jpg,.png" // ✅ no .svg, .php, .zip
                            name="file"
                            {...register("file", {
                              required: "This is required.",
                              validate: {
                                allowedExtensions: (value) => {
                                  const allowedTypes = [
                                    "application/pdf",
                                    "application/msword",
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/vnd.ms-excel",
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                  ];

                                  const file = value?.[0];
                                  if (file && !allowedTypes.includes(file.type)) {
                                    return "Only .pdf, .doc, .docx, .xls, .xlsx, .jpeg, .jpg, .png files are allowed.";
                                  }
                                  return true;
                                },
                              },
                            })}
                            onChange={(event) => {
                              setExcel(event.target.files);
                            }}
                          />
                          {errors.file && (
                            <ErrorLabel message={errors.file?.message} />
                          )}
                        </div>

                      </div>
                    </div>
                    <div className="form-actions border-0 float-none mt-1">
                      {
                        loading ?
                          <button
                            id="add_edit_cd_balance"
                            className="btn btn-primary shadow round text-uppercase me-2"
                            type="submit"
                          >
                            <div className="d-flex align-items-center">
                              Submit
                              <span
                                id="add-edit-cd-balance-loader"
                                className="spinner-border spinner-border-sm ml-half hidden"
                              ></span>
                            </div>
                          </button>
                          :
                          <button
                            id="add_edit_cd_balance"
                            className="btn btn-primary shadow round text-uppercase me-2"
                            type="submit"
                          >
                            <div className="d-flex align-items-center">
                              Submit
                            </div>
                          </button>
                      }
                      <button
                        className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                        onClick={(event) => {
                          props.handleClose();
                          event.preventDefault();
                        }}
                      >
                        {" "}
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CdAddEdit;
